import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'shared-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent {

  @Input('modal-type')
  public modalType: 'Info' | 'Confirmation' = 'Info';

  @Input('title')
  public title: string = '';

  @Input('message')
  public message: string = '';

  @Input('sub-message')
  public subMessage: string = '';

  @Input('link-text')
  public linkText: string = '';

  @Input('is-closing-modal')
  public isClosingModal: boolean = false;

  @Output('onResult')
  public onResult: EventEmitter<'Confirm' | 'Close' | 'Accept' | 'Cancel' | 'Link'> = new EventEmitter();

  /**
   * Event to emit a modal type.
   * @param result Modal type.
   */
  public onResultEvent(result: 'Confirm' | 'Close' | 'Accept' | 'Cancel' | 'Link' = 'Accept') {
    this.onResult.emit(result);
  }
}
